import e from "./ImageGallery.module.js";
import { GalleryArrows as t, GalleryFrame as n } from "./GalleryFrame.js";
import { Modal as r } from "../Modal/Modal.js";
import { clampIndex as i, stepIndex as a } from "./types.js";
import { useEffect as o, useRef as s, useState as c } from "react";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { XIcon as f } from "@phosphor-icons/react";
//#region lib/components/ImageGallery/ImageLightbox.tsx
function p({ images: p, open: m, onClose: h, initialIndex: g = 0, infinite: _ = !1, objectFit: v = "contain", disableAnimation: y = !1, footer: b, onIndexChange: x, headerActions: S }) {
	let [C, w] = c(g), T = s(!1);
	o(() => {
		m && w(i(g, p.length));
	}, [
		m,
		g,
		p.length
	]);
	let E = i(C, p.length), D = p[E];
	o(() => {
		let e = m && !T.current;
		T.current = m, m && !e && x?.(E);
	}, [
		m,
		E,
		x
	]);
	function O(e) {
		w((t) => a(t, e, p.length, _));
	}
	return /* @__PURE__ */ u(r, {
		open: m,
		onOpenChange: (e) => {
			e || h();
		},
		contentProps: { "aria-label": "Expanded image" },
		overlayProps: { style: {
			backgroundColor: "#000",
			opacity: 1
		} },
		unwrappedContent: /* @__PURE__ */ u("div", {
			className: e.fullscreen,
			children: D && /* @__PURE__ */ u(n, {
				image: D,
				objectFit: v,
				disableAnimation: y,
				footer: b,
				fullscreen: !0,
				testId: "gallery-expanded-image",
				arrows: /* @__PURE__ */ u(t, {
					canPrev: _ || E > 0,
					canNext: _ || E < p.length - 1,
					onPrev: () => {
						O(-1);
					},
					onNext: () => {
						O(1);
					},
					size: 24
				}),
				action: /* @__PURE__ */ d(l, { children: [S && /* @__PURE__ */ u("div", {
					className: e.headerActions,
					children: S
				}), /* @__PURE__ */ u("button", {
					type: "button",
					className: e.close,
					"aria-label": "Close",
					onClick: h,
					children: /* @__PURE__ */ u(f, { size: 20 })
				})] })
			})
		})
	});
}
//#endregion
export { p as ImageLightbox };
